import { CompanyInfo } from '@/modules/common/models';
import { CompanySide } from '@/modules/user-accounts/types/user-accounts';
import { Side } from '@/connect';

export function formatCompanyName(cp: CompanyInfo): string {
  return `${cp.companyName} (${cp.displayId})`;
}

export function companySideFromSide(side: Side): CompanySide {
  switch (side) {
    case Side.BORROW:
      return 'BORROWER';
    case Side.LOAN:
      return 'LENDER';
    default:
      return 'ALL';
  }
}
